import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { AlertService } from 'src/app/_services/alert.service';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { GridApi, ColumnApi, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Location } from '@angular/common';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { environment } from 'src/environments/environment';
import { SideNavService } from '../../layout/sidebar/side-name.service';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { ScreeningUtilityService } from './screening-utility-service';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';
const PAN_REG = /^[A-Z]{5}\d{4}[A-Z]$/;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'

export interface CustomerFilter {
  "columns"?: any;
  "name"?: string,
  "mid"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "dateFrom"?:string,
  "dateTo"?:string,
  "sendDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "rid"?:string,
  "Status"?:string,
  "user_type"?:string
}

export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

@Component({
  selector: 'app-screening-utility',
  templateUrl: './screening-utility.component.html',
  styleUrls: ['./screening-utility.component.scss']
})
export class ScreeningUtilityComponent implements OnInit {
  
  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: string ;
  public resellerPartnerId:string;
  public Status:string;
 public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public selectedMerchant: string;  
  totalRecords: any;
  merchantStatus: any;
  modalConfigBlocked: ModalConfig;
  user_type:'NULL';
  tableInfo: any;
  maxSize: number;
  ellipses: boolean= true;
  private gridApi!: GridApi;
   public rowData!: IMerchantData[];
   collectiondata: number=0;
   collectionSize: number = 0;
   currentPage: number = 1;
   public permissions: any = '';
   Resultdata: any;
   resellerListOptions: any;
   merchantStatusdata: any;
   private gridColumnApi!: ColumnApi;
   currentDate:any=new Date();
   private filterObj: any = {};
   globalSearch: string = '';
   private innerWidth: number;
   modalConfigAdd: ModalConfig;
   modalConfigEdit: ModalConfig;
   modalConfigMerchant: ModalConfig;
   modalConfigReport: ModalConfig;
   image : any;
   mindatadis: boolean = true;
   loading: boolean = false;
   pageNumber : number = 0;
   minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;

   public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent;
  @ViewChild('filStatus') private filStatus: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate: FormControl;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;

  public columnDefs: ColDef[] = [
    {field: 'screeningId',headerName: 'Screening ID',lockVisible:true,sortable:false, resizable: true, cellRenderer: 'agGroupCellRenderer'},
    {field: 'fullName', headerName: 'Fullname',lockVisible:true,sortable:false,},
    {field: 'id',headerName: 'ID', hide: true},
    {field: 'screeningProviderCode',headerName: 'Service Provider Code',lockVisible:true,sortable:false,},
    {field: 'screeningStatus', headerName: 'Screening Status',lockVisible:true,sortable:false,},
    {field: 'createdOn',headerName: 'Created On',lockVisible:true,sortable:false,},
    {field: 'actions',headerName: 'Screening Report',lockVisible:true,sortable:false, width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
      {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.screeningId
            console.log("Row clicked :"+this.tableInfo);
            // (window as any).open("https://www.weenysoft.com/images/sample-pdf-2.png", "_blank");
                  this.utilityService.getUtilityPdfById(this.tableInfo)
                .subscribe((data:any) => {
                  console.log(data);
                  var reader = new FileReader();
                  reader.readAsDataURL(data.body); 
                  new Promise((resolve, reject) =>{ 
                    reader.onloadend = function() {
                      resolve(reader.result);                
                    }
                  }).then(data=>{
                    this.image = data;
                    this.ScreeningReportEvent.emit(data);
                    // this.downloadPdf(data);
                    return this.modalReportComponent.open();  
                  });
                  })
                  
          },
          buttonIconClass: 'icon-eye'
        },
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.screeningId
            console.log("Row clicked :"+this.tableInfo);
            // (window as any).open("https://www.weenysoft.com/images/sample-pdf-2.png", "_blank");
            this.utilityService.getUtilityPdfById(this.tableInfo)
                .subscribe((data:any) => {
                  console.log(data);
                  var reader = new FileReader();
                  reader.readAsDataURL(data.body); 
                  new Promise((resolve, reject) =>{ 
                    reader.onloadend = function() {
                      resolve(reader.result);                
                    }
                  }).then(data=>{
                    this.image = data;
                    // this.ScreeningReportEvent.emit(data);
                    this.downloadPdf(data,param.data.fullName);
                    // return this.modalReportComponent.open();  
                  });
                  })
                  
          },
          buttonIconClass: 'icon-arrow-down'
        },
      ]
  }
    // {field: 're_kyc_day',tooltipField: 're_kyc_day', headerName: 'Re KYC Date',},
    // {field: 'city', tooltipField: 'city', headerName: 'City',hide: true},
    // {field: 'created_on', headerName: 'Created On Formatted',  filter: 'agDateColumnFilter', valueFormatter: dateFormatter},
    // {field: 'status', headerName: 'Status Formatted', minWidth: 120, valueFormatter: statusFormatter},
    // {field: 'actions',headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
    //    {
    //       clicked: async (event: any, param: any) => {
    //         this.tableInfo = param.data.registeredMobile
    //         console.log("Row clicked :"+this.tableInfo);
    //         var mobile = this.tableInfo;
    //         console.log("Mobile :"+mobile);
    //         if(window.confirm("Do you want to approved this "+param.data.fullName+" customer")){
            
    //           //put your delete method logic here

    //           this.merchantService.customerStatusApprove(mobile)
    //           .subscribe((data) => {
    //             console.log("Response"+JSON.stringify(data));
    //             // this.alertService.successAlert(JSON.stringify(data.text));
    //             this.alertService.successAlert("Customer Successfully Approved");
    //             window.location.reload();
    //             })
    //           }

    //         // this.BlockedmerchantSelectEvent.emit(this.tableInfo);
    //         // return await this.modalblockedComponent.open();
          
    //       },
    //       buttonIconClass: 'icon-check'
    //     },
    //     {
    //       clicked: async (event: any, param: any) => {
    //         this.tableInfo = param.data.registeredMobile
    //         console.log("Row clicked :"+this.tableInfo);
    //         var mobile = this.tableInfo;
    //         console.log("Mobile :"+mobile);
    //         if(window.confirm("Do you want to reject this "+param.data.fullName+" customer")){
    //           //put your delete method logic here

    //           this.merchantService.customerStatusReject(mobile)
    //           .subscribe((data) => {
    //             console.log("Response"+JSON.stringify(data));
    //             // this.alertService.successAlert(JSON.stringify(data.text));
    //             this.alertService.successAlert("Customer Successfully Rejected");
    //             window.location.reload();
    //             })

    //         }

    //         // this.BlockedmerchantSelectEvent.emit(this.tableInfo);
    //         // return await this.modalblockedComponent.open();
          
    //       },
    //       buttonIconClass: 'icon-x'
    //     }
    //   ]
    // }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  
  constructor(private menuService: MenusService,private ngbCalender: NgbCalendar,private location : Location,private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService,private utilityService : ScreeningUtilityService,private ngbDateParserFormatter: NgbDateParserFormatter, private exportTrackingService: ExportTrackingService) {
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
  }
  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    console.log(path)
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalConfigReport = {
      modalTitle: "Utility Screening Report",
      modalSize: 'xl',
      css : "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
  }

  downloadPdf(data:any,info:any) {
    //  alert("data==="+data+"  ,   Merchant======"+Merchant)
  if(data){
      const linkSource =data;
      const downloadLink = document.createElement('a');
      const fileName = info+'_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false
    }else{
      this. mindatadis = false;
      this.loading = false
    }
    }

  merchantStatusDropdown() {
    return this.merchantService.getMerchantStatus()
        // .post(
        //   `${API_URL}/GetDropdown`, postdata
        // )
        .subscribe((res) => (this.merchantStatusdata = res,console.log("res",this.merchantStatusdata)));
  
    }

    MerchnatList() {
      let reqData = {
        "name": ""
      }
      console.log("request body", reqData)
      this.merchantService.getMerchantBYName(reqData).subscribe((res:any) => {
          this.Resultdata = res
          console.log("merchant mid",res)
        });
    }

  setPageSize(){
    // this.columnDefs = this.columnDefs.map((col)=>{
    //   if(col.field == 'actions'){
    //     col.pinned = "right";
    //   }
    //   return col;
    // });
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }
  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }


  onExportCSV() {
    debugger
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Screening_Utility' + "_" + referenceId;

    const filter: CustomerFilter = {}
  
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }

    return this.utilityService.getUtilityScreeningList(this.searchMID,this.resellerPartnerId,this.merchantStatusdata,this.pageSize,this.pageNumber,filter.dateFrom,filter.dateTo)
      .subscribe((data:any) => {
        debugger
        const expData: any[] = [];
        (data.response.data.content).forEach((curr: any) => {
          const tempRec: any = {}
          // this.tableSelectedColumn.forEach((col) => {
          //   if (col?.field) tempRec[col?.field] = curr[col?.field]
          // })
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions"))

            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]

          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  // Excel export method with audit tracking
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    // First, track the export for audit logging
    this.exportTrackingService.trackExcelExport(
      excelFileName,
      json.length,
      'SCREENING_UTILITY',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Screening utility export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        this.performExcelExport(json, excelFileName);
      }
    });
  }

  // Perform the actual Excel export after audit tracking
  private performExcelExport(json: any[], excelFileName: string): void {
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // Helper method to get current filter state for audit logging
  private getCurrentFilters(): any {
    return {
      merchantName: this.searchMerName || '',
      merchantId: this.searchMID || '',
      resellerPartnerId: this.resellerPartnerId || '',
      status: this.Status || '',
      dateFrom: this.searchFromDate ? `${this.searchFromDate.year}-${this.searchFromDate.month}-${this.searchFromDate.day}` : '',
      dateTo: this.searchToDate ? `${this.searchToDate.year}-${this.searchToDate.month}-${this.searchToDate.day}` : ''
    };
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  onSearchBtnClick($event: Event) {
    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }
    console.log(filter.startDate)
    console.log(filter.endDate)
    console.log(this.searchMID)
    console.log(this.resellerPartnerId)
    console.log(this.merchantStatusdata)
    this.pageNumber = 0;
    this.currentPage = 1;
    return this.utilityService.getUtilityScreeningList(this.searchMID,this.resellerPartnerId,this.merchantStatusdata,this.pageSize,this.pageNumber,filter.dateFrom,filter.dateTo)
      .subscribe((data:any) => {
        this.rowData = data.response.data.content,
        this.collectiondata = data.response.data.content
        this.collectionSize= data.response.data.totalElements
        if(this.rowData.length <=0){
          this.alertService.errorAlertWithMessage("No records present");
          return }
      });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    console.log("Edit CLicked" + param.data.idenfoId);
    return await this.router.navigate(['/screeningUtilityEdit'], {

      queryParams: {
        mid: param?.data?.screeningId,
      }
    })

  }
  
  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }
    this.pageNumber = (param-1);
    console.log(this.pageNumber);
    this.utilityService.getUtilityScreeningList(this.searchMID,this.resellerPartnerId,this.merchantStatusdata,this.pageSize,this.pageNumber,filter.dateFrom,filter.dateTo)
      .subscribe((data:any) => {
          this.rowData = data.response.data.content;
          this.collectionSize = data.response.data.totalElements
          this.collectiondata = data.response.data.content

          this.gridApi.applyTransaction({add: this.rowData});
          this.collectionSize=data.response.data.totalElements
        }
      );
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: CustomerFilter = {}
    
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }
    this.utilityService.getUtilityScreeningList(this.searchMID,this.resellerPartnerId,this.merchantStatusdata,this.pageSize,this.pageNumber,filter.dateFrom,filter.dateTo)
      .subscribe((data:any) => (this.rowData = data.response.data.content, 
        this.collectiondata = data.response.data.content,
        this.collectionSize= data.response.data.totalElements,
         this.gridApi.applyTransaction({add: this.rowData})));

  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }
    return this.utilityService.getUtilityScreeningList(this.searchMID,this.resellerPartnerId,this.merchantStatusdata,this.pageSize,this.pageNumber,filter.dateFrom,filter.dateTo)
      .subscribe((data:any) => {
        console.log("Data : "+data);
        this.rowData = data.response.data.content;
       
        console.log(" this.rowData= masterlist==="+ JSON.stringify(this.rowData))
        this.collectiondata = data.response.data.content
        this.collectionSize=data.response.data.totalElements
        this.totalRecords =  data.response.data.totalElements
      });
  }

  resetFilter(){
    this.searchFromDate = {year: 0,month: 0,day: 0,};
    this.searchToDate = {year: 0,month: 0,day: 0,};
    this.searchMID = "";
    this.resellerPartnerId = ""
    this.filStatus.handleClearClick();
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.filSearchMerName.handleClearClick();
      this.filSearchMID.handleClearClick();
      this.filResellerPartnerId.handleClearClick();
      this.filStatus.handleClearClick();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  changeDate(){
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
  }

  changeEndDate()
  {
    this.currentDate = this.searchToDate;
    this.maxDateFrom=this.searchToDate;
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onSortChange(event : any){    
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  allowAlfanumeric($event: Event): void {
    if(this.searchMID.length>10)
    {
      return
    }

    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
    const filter: CustomerFilter = {}
    if(this.ngbDateParserFormatter.format(this.searchFromDate)== "0-00-00"){
      filter.dateFrom = "";
    }else{
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate)+" 00:00:00";
    }

    if(this.ngbDateParserFormatter.format(this.searchToDate)== ""){
      filter.dateTo = "";
    }else{
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate)+" 23:59:59";
    }
    
    return this.utilityService.getUtilityScreeningList(this.searchMID,this.resellerPartnerId,this.merchantStatusdata,this.pageSize,this.pageNumber,filter.dateFrom,filter.dateTo)
      .subscribe((data:any) => (this.rowData = data.response.data.content, 
        this.collectiondata = data.response.data.content,  
        this.collectionSize= data.response.data.totalElements
        ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }
}


